<template>
    <div class="context">
        <div class="header">
            <div class="title">我的患者</div>
            <div class="btn_box">
                <!--
                <div class="btn nomal_btn" @click="addIll">
                    <i class="el-icon-plus"></i>
                    添加患者
                </div>
                -->
            </div>
        </div>
        <div class="table_box">
            <div class="search_box">
                <el-form :model="searchForm"
                         class="search_form"
                         size="small">
                    <el-form-item label="姓名:">
                        <div class="radio_box">
                            <el-input class="width_220"
                                      @change="getTableData()"
                                      clearable
                                      v-model="searchForm.input">
                            </el-input>
                            <div class="search_btn">
                                <el-button type="primary"
                                           @click="getTableData()">
                                    搜索
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="瘤种:">
                        <div class="input_box">
                            <div :class="searchForm.tumour_id === ''?'actived_btn':''"
                                 @click="clearSearch('tumour_id')"
                                 class="btn">不限
                            </div>
                            <div v-for="(item, index) in allIllData"
                                 :key="index"
                                 :class="searchForm.tumour_id === item.tumour_id?'actived_btn':''"
                                 @click="changeCell(item.tumour_id, 'tumour_id')"
                                 class="btn">
                                {{item.name}}
                            </div>
                        </div>
                    </el-form-item>
                    <!--
                    <el-form-item label="阶段:"
                                  v-if="searchForm.tumour_id && stangesData && stangesData.length > 0">
                        <div class="input_box">
                            <div :class="searchForm.cycle_id === ''?'actived_btn':''"
                                 @click="clearSearch('cycle_id')"
                                 class="btn">不限
                            </div>
                            <div v-for="(item, index) in stangesData"
                                 :key="index"
                                 :class="searchForm.cycle_id === item.cycle_id?'actived_btn':''"
                                 @click="changeCell(item.cycle_id, 'cycle_id')"
                                 class="btn">
                                {{item.name}}
                            </div>
                        </div>
                    </el-form-item>-->
                </el-form>
            </div>

            <el-table :data="tableData"
                      stripe
                      width="100%"
                      :height="tableHeight">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="用户标签"
                                 show-overflow-tooltip
                                 width="220"
                                 header-align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.tags && scope.row.tags.length > 0">
                            <el-tag v-for="(item, index) in scope.row.tags"
                                    style="margin-right: 5px"
                                    size="mini"
                                    :key="index">
                                {{item}}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <!--
                        <el-button type="text" @click="lookIll(scope.row)">
                            <i class="el-icon-search"></i>
                            查看
                        </el-button>
                        <span class="table_btn" @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_btn" @click="setWarn(scope.row)">
                            <i class="el-icon-timer"></i>
                            提醒
                        </span>-->
                        <span class="table_btn"
                              v-if="scope.row.status == 2"
                              @click="openAudit(scope.row)">
                            <i class="el-icon-coordinate"></i>
                            审核
                        </span>
                        <!-- <span
                              @click="auditNot(scope.row)"
                              class="table_del_btn">
                            <i class="el-icon-close"></i>
                            拒绝
                        </span> -->
                        <span  class="table_del_btn" @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!---->
        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import config from '@/global/config'
    import {clone} from "../../global/utils";

    export default {
        name: "tableView",
        components: {
        },
        data() {
            const showSex = (row, column, cellValue, index) => {
                return cellValue == 1 ? '男' : cellValue == 2 ? '女' : '无';
            };
            const showMarriage = (row, column, cellValue, index) => {
                return cellValue == 1 ? '未婚' : cellValue == 2 ? '已婚' : '无';
            };
            return {
                activeName: 'first',
                searchForm: {
                    input: '',
                    tumour_id: '',
                    cycle_id: '',
                },
                stangesData: [],

                sexList: [
                    {name: '男', id: '1'},
                    {name: '女', id: '2'},
                ],
                ageList: [
                    {name: '30以下', id: '0,30'},
                    {name: '30~40岁', id: '30,40'},
                    {name: '40~50岁', id: '40,50'},
                    {name: '50~60岁', id: '50,60'},
                    {name: '60以上', id: '60,200'},
                ],
                hosList: [
                    {label: '仁济', id: '1'},
                    {label: '瑞金', id: '2'},
                    {label: '同济', id: '3'},
                    {label: '新华', id: '4'},
                    {label: '龙华', id: '5'},
                ],

                tableHeight: null,
                tableData: [],
                columnData: [
                    {label: '姓名', prop: 'name', width: 100},
                    {label: '填报姓名', prop: 'patient_name', width: 100},
                    {label: '电话', prop: 'phone'},
                    {label: '性别', prop: 'sex', width: 70, formatter: showSex},
                    {label: '年龄', prop: 'age', width: 70},
                    {label: '医院', prop: 'hospital'},
                    {label: '瘤种', prop: 'tumour_name'},
                    {label: '阶段', prop: 'tumour_cycle_name'},
                ],
                total: 0,
                currentPage: 1,
                pageSize: 10,
            }
        },
        computed: {
            ...mapState("comInformationData", [
                'allIllData'
            ]),
            ...mapState('illuserData', [
                'selectRow',
                'last_search_form',
            ])
        },
        mounted() {
            if (this.last_search_form && JSON.stringify(this.last_search_form) !== '{}') {
                this.searchForm = clone(this.last_search_form);
                if (this.searchForm.tumour_id) {
                    let item = this.allIllData.filter(v =>
                        v.tumour_id == this.searchForm.tumour_id);
                    this.stangesData = item[0].cycle_list;
                }
            }
            this.getTableData();
        },
        methods: {
            ...mapMutations('illuserData', {
                setRow: 'setRow',
                setLastSearchForm: 'setLastSearchForm',
            }),
            addIll() {
                let params = {
                    row: null,
                    title: '添加患者'
                };
                this.setRow(params);
                this.$emit('changeTopTab', 'illView')
            },
            lookIll(row) {
                let params = {
                    row: row,
                    title: `查看资料（${row.name}）`
                };
                this.setRow(params);
                this.$emit('changeTopTab', 'illView')
            },
            editRow(row) {
                let params = {
                    row: row,
                    title: `修改资料（${row.name}）`
                };
                this.setRow(params);
                this.$emit('changeTopTab', 'illView')
            },
            setWarn(row) {
                let isProd = process.env.NODE_ENV === "production";
                let base_url = isProd? window.location.origin:config.BASE_URL;
                let item = {
                    eventBus: true,
                    iframe: base_url + '/add/remind/list?user_id=' + row.user_id
                };
                this.$eventBus.$emit('changeRouterWarning', item)
            },

            openAudit(row) {
                this.httpGet(`/user/patient/${row.patient_id}`).then(res => {
                    let params = {
                        row: res.data,
                        title: '审核患者'
                    };
                    this.setRow(params);
                    this.$emit('changeTopTab', 'illView')
                })
            },
            auditNot(row) {
                let url = '/user/patient/' + row.patient_id;
                let params = {
                    status: 4,
                };
                this.httpPut(url, params).then(res => {
                    this.$message.success('拒绝患者成功！');
                    this.getTableData()
                }).catch(err => {
                    this.$message.error(err.msg)
                })
            },

            delRow(row) {
                this.$confirm('确定删除该患者么？').then(() => {
                    this.httpDel(`/user/patient/${row.patient_id}`).then(res => {
                        this.$message.success('删除成功！');
                        this.getTableData()
                        if (this.tableData.length === 1) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage -1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }
                    })
                }).catch(() => {})

            },

            clearSearch(val) {
                this.searchForm[val] = '';
                if (val === 'tumour_id') {
                    this.searchForm.cycle_id = ''
                }
                this.getTableData();
            },
            changeCell(item, val) {
                this.searchForm[val] = item;
                if (val === 'tumour_id') {
                    this.selectIll(item)
                } else {
                    this.getTableData()
                }
            },
            selectIll(id) {
                let item = this.allIllData.filter(v => v.tumour_id == id);
                // console.log(item, '318');
                this.stangesData = item[0].stage_list;
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                console.log('get_data');
                let params = {
                    name: this.searchForm.input,
                    tumour_id: this.searchForm.tumour_id,
                    tumour_cycle_id: this.searchForm.cycle_id,
                    page: v,
                    page_size: this.pageSize
                };
                this.httpGet('/user/patient', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.setLastSearchForm(clone(this.searchForm));
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
                this.getTableHeight();
            },

            getTableHeight() {
                this.$nextTick(() => {
                    let height = document.getElementsByClassName('table_box')[0].offsetHeight;
                    let search_height = document.getElementsByClassName('search_box')[0].offsetHeight;

                    this.tableHeight = height - search_height - 5 + 'px';
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246,247,248);
    $btn_border: rgb(246,247,248);
    .context {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background: $view_background;
        position: relative;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            .title {
                padding-right: 20px;
            }
            .btn_box {
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }
        .table_box {
            width: 100%;
            padding: 0 10px;
            height: calc(100% - 95px);
            overflow: hidden;
            overflow-y: auto;
            box-sizing: border-box;
            .search_box {
                padding: 5px 10px;
                .radio_box {
                    display: flex;
                    line-height: 30px;
                    .search_btn {
                        padding-left: 15px;
                    }
                }
                .input_box {
                    display: flex;
                    flex-wrap: wrap;
                    .btn {
                        height: 25px;
                        line-height: 25px;
                        font-size: .875rem;
                        padding: 0 10px;
                        box-sizing: border-box;
                        margin: 5px 10px;
                        cursor: pointer;
                        white-space: nowrap;
                    }
                    .actived_btn {
                        box-sizing: border-box;
                        border: 1px solid #38adff;
                        border-radius: 3px;
                    }
                }
            }

        }

        .bottom_page {
            padding-top: 5px;
            width: 100%;
            text-align: center;
        }
    }
</style>